"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FullScreenOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28 2H4a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2zm0 26H4V4h24z"/><path d="M13.71 13.71a1 1 0 01-1.42 0L8 9.41V12a1 1 0 01-2 0V7a1 1 0 01.08-.38 1 1 0 01.54-.54A1 1 0 017 6h5a1 1 0 010 2H9.41l4.3 4.29a1 1 0 010 1.42zM13.71 19.71L9.41 24H12a1 1 0 010 2H7a1 1 0 01-.38-.08 1 1 0 01-.54-.54A1 1 0 016 25v-5a1 1 0 012 0v2.59l4.29-4.3a1 1 0 011.42 1.42zM26 20v5a1 1 0 01-.08.38 1 1 0 01-.54.54A1 1 0 0125 26h-5a1 1 0 010-2h2.59l-4.3-4.29a1 1 0 011.42-1.42l4.29 4.3V20a1 1 0 012 0zM26 7v5a1 1 0 01-2 0V9.41l-4.29 4.3a1 1 0 01-1.42 0 1 1 0 010-1.42L22.59 8H20a1 1 0 010-2h5a1 1 0 01.38.08 1 1 0 01.54.54A1 1 0 0126 7z"/>';
var FullScreenOutlineSVG = function FullScreenOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FullScreenOutlineSVG = FullScreenOutlineSVG;
FullScreenOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FullScreenOutlineSVG);
exports.default = _default;